<template>
  <div>
    <el-form-item :label="$t('SearchWhseClient.whName')" v-if="visible">
      <el-select ref="whId" v-model="localWhId" placeholder="" style="width:100%" required :disabled="disabled">
        <el-option v-for="(whse,index) in this.whseData" :key="index" :value="whse.whId"
                   :label="whse.name" @click.native="getClient"/>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('SearchWhseClient.clientName')" v-if="visible">
      <el-select @change="putWhseClient" ref="clientCode" v-model="localClientCode" placeholder="" style="width:100%" required :disabled="disabled">
        <el-option v-for="(client,index) in this.clientData" :key="index" :value="client.clientCode"
                   :label="client.name"/>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  name: 'EditWhseClient',
  props: {
    icon: {  // 显示图标
      type: String,
      default: ''
    },
    size: {  // 尺寸
      type: String,
      default: 'mini'
    },
    type: {  // 类型
      type: String,
      default: null
    },
    loading: {  // 加载标识
      type: Boolean,
      default: false
    },
    disabled: {  // 是否禁用
      type: Boolean,
      default: false
    },
    visible: {  // 是否显示，默认显示
      type: Boolean,
      default: true
    },
    perms: {  // 权限标识，外部使用者传入
      type: String,
      default: null
    },
    whId: String,
    clientCode: String
  },
  data() {
    return {
      localWhId: '',
      localClientCode: '',
      whseData:Object,
      clientData:Object,
      whseClientData: {
        whId:null,
        clientCode:null
      }
    }
  },
  watch: {
    // 外部传入的 whId 变化时，同步到本地并重新获取货主数据
    whId(newVal) {
      this.localWhId = newVal || ''
      if (newVal) {
        this.getClient()
      } else {
        this.localClientCode = ''
      }
    },
    clientCode(newVal) {
      this.localClientCode = newVal || ''
    }
  },
  methods: {
    //获取仓库下拉列表
    getWhse: function (){
      let user = sessionStorage.getItem('user')
      let objUserName = {userName:user}
      this.$wmsApi.globalOption.getWhse(objUserName)
      .then(res =>
        {
          //请求返回的数据
          this.whseData = res.data
          // 外部传了非空 whId prop 且在列表中，保持 prop 值不动，让 watch -> getClient 去拉货主
          if (this.whId && this.whseData.some(w => w.whId === this.whId)) {
            this.localWhId = this.whId
          } else {
            // 没有合法 prop，默认选第一个仓库
            this.localWhId = this.whseData[0].whId
          }
          this.getClient()
        })
    },
    //获取货主下拉列表
    getClient: function (){
      let objWhId = {whId:this.localWhId}
      this.$wmsApi.globalOption.getClient(objWhId)
        .then(res =>
        {
          //请求返回的数据
          this.clientData = res.data
          // 外部传了非空 clientCode prop 且在列表中，保持 prop 值不动
          if (this.clientCode && this.clientData.some(c => c.clientCode === this.clientCode)) {
            this.localClientCode = this.clientCode
          } else if (!this.clientCode || !this.clientData.some(c => c.clientCode === this.clientCode)) {
            // clientCode prop 为空或不在列表中，自动选第一个货主
            this.localClientCode = this.clientData.length > 0 ? this.clientData[0].clientCode : ''
          }
          this.putWhseClient()
        })
    },
    putWhseClient: function (){
      return this.$emit('edit-whse-event',this.localWhId,this.localClientCode);
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) & !this.disabled
    }
  },
  created() {
    // 外部传入了 whId/clientCode，先设置到本地 data，再拉列表
    this.localWhId = this.whId || ''
    this.localClientCode = this.clientCode || ''
    this.getWhse()
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Core/EditWhseClient.vue